// Shared platform-style helper. Web-only style fragments (gradients, box-shadow,
// cursor, transition, position:fixed, backdrop-filter, etc.) are unsupported by
// React Native, so we gate them behind `web(...)`. Replaces the ~7 copy-pasted
// per-file `const web = s => isWeb ? s : {}` definitions.
//
// The cast to the RN style type is deliberate and centralized HERE (one place),
// so screens never need `as any` for web-only style keys.

import { Platform } from 'react-native';
import type { ViewStyle, TextStyle, ImageStyle } from 'react-native';

export const isWeb = Platform.OS === 'web';

type Style = ViewStyle | TextStyle | ImageStyle;

/** Returns `style` on web, an empty object elsewhere. Accepts web-only keys. */
export function web<T extends Record<string, unknown>>(style: T): Style {
  return (isWeb ? style : {}) as Style;
}
